import {useState, useEffect} from 'react'

function getWindowDimensions() {
    const {innerWidth: width, innerHeight: height} = window
    return {
        // prevent rounding error
        width: width - 1,
        height: height - 1
    }
}

export default function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions())

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions())
        }

        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    return windowDimensions
}
